import { Accordion, Eyebrow, Reveal, SafeImage } from '../ui';

export type Block = { id: string; title: string; text: string; image?: string };

/**
 * « Comment nous nous engageons »: titre et accroche à gauche, engagements en accordéon à droite
 * (le premier est ouvert; la photo, quand elle existe, s'affiche dans le panneau ouvert).
 */
export default function AlternatingBlocks({ eyebrow, heading, intro, blocks }: { eyebrow: string; heading: string; intro?: string; blocks: Block[] }) {
  if (blocks.length === 0) return null;
  return (
    <section className="bg-surface py-16 text-black md:py-28">
      <div className="site-container grid gap-10 lg:grid-cols-[1fr_1.25fr] lg:gap-24">
        <div>
          <Eyebrow className="mb-4">{eyebrow}</Eyebrow>
          <Reveal>
            <h2 className="font-display text-[2rem] font-bold normal-case leading-[1.1] tracking-normal text-black md:text-[2.75rem]">{heading}</h2>
            {intro && <p className="mt-6 max-w-md text-[1.0625rem] leading-relaxed">{intro}</p>}
          </Reveal>
        </div>
        <Reveal delay={0.08}>
          <Accordion
            defaultOpen={blocks[0].id}
            items={blocks.map((b) => ({
              id: b.id,
              title: b.title,
              content: (
                <div className="grid gap-5 sm:grid-cols-[1fr_12rem] sm:items-start">
                  <p className="text-[1.0625rem] leading-relaxed text-black">{b.text}</p>
                  <SafeImage src={b.image} alt={b.title} className="aspect-[4/3] w-full object-cover" />
                </div>
              ),
            }))}
          />
        </Reveal>
      </div>
    </section>
  );
}
